



































































































































































































































































import DragUpload from '@/components/util/DragUpload.vue';
import { Component, Vue } from 'vue-property-decorator';
import { User } from 'oidc-client';
import { Asset, AssetsApi, PerformoSettings, Property } from 'performo-api';

import DetailLayout from '@/components/system/DetailsLayout.vue';
import BuildingDisplayComponent from '@/components/system/BuildingDisplayComponent.vue';
import DocumentList from '@/components/documents/DocumentListView.vue';
import { ColumnDisplayOption } from '@/models/ColumnDisplayOption';
import AssetMeterReadings from '@/components/assets/AssetMeterReadings.vue';
import AddMeterReading from '@/components/assets/AddMeterReading.vue';
import AssetAttributes from '@/components/assets/AssetAttributes.vue';

import AssetOrderHistory from '@/components/assets/AssetOrderHistory.vue';
import { mapGetters } from 'vuex';

@Component({
  components: {
    DetailLayout,
    BuildingDisplayComponent,
    DocumentList,
    AssetOrderHistory,
    DragUpload,
    AssetMeterReadings,
    AssetAttributes,
    AddMeterReading
  },
  computed: mapGetters({
    api: 'assetsApi',
    settings: 'settings',
    currentProperty: 'currentProperty'
  })
})
export default class AssetDetail extends Vue {
  private api!: AssetsApi;

  private settings!: PerformoSettings;
  private asset!: Asset;
  private currentProperty!: Property;
  private photo!: Blob;

  data() {
    // this lets the undefined order!, photo! refs become reactive
    // https://class-component.vuejs.org/guide/class-component.html#data
    return {
      asset: undefined,
      photo: undefined
    };
  }

  private async mounted() {
    await this.refresh();
  }

  private async refresh(data?: Asset) {
    if (data) {
      this.asset = data;
    } else {
      this.asset = await this.api.getAsset({
        assetId: parseInt(this.$route.params.id)
      });
    }
    this.photo = await this.api.getAssetPhotoByIndex({
      assetId: parseInt(this.$route.params.id),
      index: 0
    });
  }

  get user(): User {
    return this.$store.state.user;
  }

  get photoSource() {
    if (!this.photo) return null;
    if (this.photo.size <= 0) return null;
    return window.URL.createObjectURL(this.photo);
  }

  private userHasInterface(interfaceName: string): boolean {
    if (!this.user.profile) {
      return false;
    } // bail out if we can't read the profile object
    if (Array.isArray(this.user.profile.interface)) {
      return this.user.profile.interface.includes(interfaceName);
    }
    return this.user.profile.interface === interfaceName;
  }

  get pmSetupsDisplayOptions(): ColumnDisplayOption[] {
    return [
      { displayName: 'PM #', columnName: 'cPMorderNum', dontSort: true },
      { displayName: 'Job Type', columnName: 'jobType', dontSort: true },
      { displayName: 'Assign To', columnName: 'assignTo', dontSort: true },
      {
        displayName: 'Next Date',
        columnName: 'scheduledStartDate',
        dateFormatKind: 1,
        dontSort: true
      },
      {
        displayName: 'Repeat',
        columnName: 'cPMSetupTypeDisplay',
        width: 150,
        dontSort: true
      },
      {
        displayName: 'Checklist',
        columnName: 'procedurename',
        width: 200,
        dontSort: true
      },
      {
        displayName: 'Supersedes',
        columnName: 'supersedesOrder',
        dontSort: true
      },
      {
        displayName: 'Description',
        columnName: 'description',
        width: 200,
        dontSort: true
      }
    ];
  }

  get movesDisplayOptions(): ColumnDisplayOption[] {
    return [
      {
        displayName: 'Date',
        columnName: 'moveDateTime',
        dateFormatKind: 3,
        dontSort: true
      },
      { displayName: 'From', columnName: 'fromLocation', dontSort: true },
      { displayName: 'To', columnName: 'toLocation', dontSort: true },
      {
        displayName: 'Status',
        columnName: 'status',
        dontSort: true
      },
      {
        displayName: 'Reason',
        columnName: 'reason',
        dontSort: true
      },
      {
        displayName: 'Received By',
        columnName: 'receivingPerson',
        dontSort: true
      },
      {
        displayName: 'Dept',
        columnName: 'receivingDept',
        dontSort: true
      }
    ];
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private successHandler(data: Asset) {
    if (this.refresh) {
      this.refresh(data);
    }
  }

  private errorHandler(error: string | Error) {
    console.log(error);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private successDocUploadHandler(data: Document) {
    this.refresh();
  }

  private errorDocUploadHandler(error: string | Error) {
    console.log(error);
  }
}
